
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="List" -->
				<el-form-item>
					<el-input  v-model="filters.CardNumber"  @keyup.enter.native="List" placeholder="卡号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="List" icon="el-icon-search">查询</el-button>
				</el-form-item>		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="ListData" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="CardNumber" label="卡号" width="200" sortable>
			</el-table-column>			
			<el-table-column prop="CreationTime" label="刷卡时间" min-width="180"  sortable>
			</el-table-column>	
				
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-tag>当前有{{Count}}位教练</el-tag> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>			        
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import { getRecord } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					CardNumber: ''
				},
				focusvalue:false,
				AuthorizationNumber:'',
				AuthorizationVisible:false,
				imgUrl:'',
				imageVisible:false,
                seeImageVisible:false,
                radio:'0',
		       Loading:false,
				Count:0,
				options:[],
				ListData:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
			}
		},
		methods: {	
			//获取列表
		
			List() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					CardNumber:this.filters.CardNumber
				};
				this.listLoading = true;
				//NProgress.start();
				getRecord(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					console.log(res.data);
					this.total = res.data.TotleCount;
					this.ListData =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							




			selsChange: function (sels) {
				this.sels = sels;
			},


   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
   	handleCurrentChange(val) {
				this.page = val;
				this.List();
			},
		},
		mounted() {
			this.List();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// Over.vue?4c14e1a6